const gbp = (v) => (v == null ? null : `£${Math.round(v).toLocaleString("en-GB")}`);

function Measure({ m, label, testId }) {
  return (
    <div data-testid={testId} className="rounded border border-stone-200 bg-white p-2">
      <div className="text-[10px] uppercase tracking-wider text-stone-500">{label}</div>
      <div className="font-chip text-lg font-semibold text-stone-900">{gbp(m.median)}</div>
      <div className="text-[10px] font-mono text-stone-400">
        {m.lq != null && m.uq != null ? `${gbp(m.lq)}–${gbp(m.uq)}` : ""}
        {m.population ? ` · n = ${m.population}` : ""}
        {m.subject_code ? ` · ${m.subject_code}` : ""}
        {m.years || m.cohort ? ` · ${m.years || `graduated ${m.cohort}`}` : ""}
      </div>
    </div>
  );
}

export const OfficialEarningsNotice = ({ official }) => {
  if (!official) return null;
  if (official.status !== "linked") {
    return (
      <div data-testid="official-earnings-unavailable" className="mt-4 rounded-lg border border-dashed border-stone-300 bg-stone-50 p-4">
        <div data-testid="official-earnings-label" className="font-chip text-base font-semibold text-stone-600">{official.label}</div>
        <p data-testid="official-earnings-reason" className="mt-1 text-xs text-stone-500">{official.reason}. Graduate earnings for this course are shown only from verified official sources.</p>
      </div>
    );
  }
  const oc = official.official_course || {};
  return (
    <div data-testid="official-earnings-linked" className="mt-4 rounded-lg border border-stone-200 bg-[#FDFBF7] p-4">
      <div className="text-[11px] uppercase tracking-wider text-stone-500">Official graduate earnings source</div>
      <p data-testid="official-earnings-course" className="mt-1 text-sm text-stone-800">
        Linked to the Discover Uni record <span className="font-medium">{oc.title}</span>{oc.award ? ` (${oc.award})` : ""}
        {oc.url && <> · <a href={oc.url} target="_blank" rel="noreferrer" className="underline">course page</a></>}
      </p>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        {official.go15 && <Measure m={official.go15} label="About 15 months after graduating" testId="official-earnings-go15" />}
        {official.leo3 && <Measure m={official.leo3} label="3 years after graduating" testId="official-earnings-leo3" />}
      </div>
      {official.not_available?.length > 0 && (
        <p data-testid="official-earnings-na" className="mt-2 text-[11px] text-stone-500">Official data not available: {official.not_available.join("; ")}.</p>
      )}
      <p className="mt-1 text-[10px] text-stone-400">Source: {official.source}. Five-year figures are shown in the LEO panel.</p>
    </div>
  );
};
